import * as React from "react";
import {Bar} from "react-chartjs-2";
import 'chartjs-plugin-colorschemes';
import {formatEuroValue} from "../reactUtils";

export default class MieteinnahmenPerYearChart extends React.Component {

    chartOptions = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    callback: function(value, index, values) {
                        return value + " €";
                    }
                }
            }]
        },
        title: {
            display:true,
            text: "Mieteinnahmen pro Saison",
            fontSize: 20
        },
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    data = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    return "Mieteinnahmen: " + formatEuroValue(data);
                }
            }
        }
    };

    render() {
        let data = this.props.data;
        return (
            <Bar data={data} options={this.chartOptions}/>
        );
    }
}